export const environment = {
  baseUrl: 'https://retention.staging-usc1.aodocs.app',
  apiUrl: '/_ah/api/',
  finraApiUrl: 'https://retention.staging-usc1.aodocs.app',
  aodocsUrl: 'https://aodocs.altirnao.com/',
  clientId: '336465149492-5cfkmf391gtfvqudfqsvp4fulf1c562o',
  gcsAPI: 'https://storage.googleapis.com/upload/storage/v1/b/{BUCKET}/o',
  ossApi: 'https://aodocs-object-storage.appspot.com/api/storage',
  version: '4.0.0',
  production: false,
  microsoftAuthEnabled: true,
  googleAuthEnabled: true,
  firebase: {
    apiKey: "AIzaSyCz9BRCOPEE5_CSgBkdEEhvnm1bM-Ras4Y",
    authDomain: "ao-docs.firebaseapp.com",
    databaseURL: "https://ao-docs.firebaseio.com",
    projectId: "ao-docs",
    storageBucket: "ao-docs.appspot.com",
    messagingSenderId: "993707107224",
    appId: "1:993707107224:web:745a8ad2d72935d21441ed",
    measurementId: "G-W218Q6KHY4"
    
  }
};
